import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Image from 'components/Image';
import MediaSmDown from 'components/Responsive/MediaSmDown';

export default function DisplayQualitySmDown({
  image, isChanging, name, nameAndLevel, nature, onClick, tooltipData,
}) {
  return (
    <MediaSmDown>
      <li className={classnames('js-item item', isChanging && 'display-quality--is-changing')}>
        <div className={classnames(
          'icon display-quality__image',
          nature === 'Status' && 'icon--circular',
        )}
        >
          <Image
            alt={name}
            icon={image}
            onClick={onClick}
            type="small-icon"
            tooltipData={tooltipData}
          />
        </div>
        <div className="item__desc">
          <span className="js-item-name item__name">{nameAndLevel}</span>
        </div>
      </li>
    </MediaSmDown>
  );
}

DisplayQualitySmDown.propTypes = {
  image: PropTypes.string.isRequired,
  isChanging: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  nameAndLevel: PropTypes.string,
  nature: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  tooltipData: PropTypes.shape({}).isRequired,
};

DisplayQualitySmDown.defaultProps = {
  nameAndLevel: undefined,
};